
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPipeComingFrom as ObiPipeComingFromElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pipe-coming-from.js';
 
 
 

 
 export const ObiPipeComingFrom = createComponent({
   react: React,
   tagName: 'obi-pipe-coming-from',
   elementClass: ObiPipeComingFromElement,
   events: {
     
   }
  });
 
 